import React, { useRef, useState } from "react";
import Header from "../../Components/Header";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import FromdateComponent from "../Reports/FromdateComponent";
import TodateComponent from "../Reports/TodateComponent";
import PayoutBrokerage from "./PayoutBrokerage";
import MTFPayout from "./MTFPayout";
import AMCPayout from "./AMCPayout";
import axios from "axios";
import { Partner_Payout_Rms } from "../../Configuration/API_URL";
import { toast } from "react-toastify";
import RoundLoader from "../../Components/Common/RoundRingLoader";
import Loader from "../../Components/Common/Loader";
import {
  CommonDate,
  ToDateCheck,
  ZeroPrefix,
} from "../../CommonMethhods/DateFunction";
import SlabWiseApPayout from "./SlabWise";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import PartnerPayoutBrokerage from "./PartnerPayoutBrokerage";
// import { dummyValue } from "./dummyPayout";

function PartnerPayout() {
  let getFormData = {};

  const storeToken = localStorage.getItem("ssoToken");
  const [loader, setLoader] = useState(false);
  const [errorResp, setErrorResp] = useState("");
  const [rmsData, setRmsData] = useState([]);
  const [insertBtnLoader, setInsertloadBtn] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [rawDownloadLoader, setrawDownloadLoader] = useState(false);
  const [fromDateError, setFromDateError] = useState("");
  const [toDateError, setToDateError] = useState("");

  const todatRef = useRef("");
  const typeRef = useRef("");
  const fromDateRef = useRef("");

  const handleType = (e) => {
    setRmsData([]);
    typeRef.current.value = e.target.value;
  };

  const EmptyResponseArray = () => {
    setRmsData([]);
  };
  const onSubmit = (e) => {
  
    let date1 = new Date(todatRef.current.value).getTime();
    let date2 = new Date(fromDateRef.current.value).getTime();
    e.preventDefault();

    if (!fromDateRef.current.value) {
    setFromDateError("From Date is Required");
  }
  if (!todatRef.current.value) {
    setToDateError("To Date is Required");
  }

    if (todatRef.current.value !== "" && fromDateRef.current.value !== "") {
      if (date1 > date2) {
        setLoader(true);
        if (typeRef.current.value !== "") {
          getApPayoutDetailList("grid", "");
          setErrorResp("");
          setFromDateError("");
          setToDateError("");
        } else {
          setLoader(false);
          EmptyResponseArray();
          setErrorResp("");
          toast.error("Please select Type");
        }
      } else {
        setErrorResp("From Date should be less than To Date ");
      }
    } 
    // else {
    //   setErrorResp("Please Select Date");
    // }
  };

  const resetBtn = () => {
    setRmsData([]);
    setErrorResp("");
    setFromDateError("");
  setToDateError("");
    // typeRef.current.value = "";
    fromDateRef.current.value = "";
    todatRef.current.value = "";
  };

  const getApPayoutDetailList = async (fileType = "grid", code = "") => {
    if(fileType !== "grid"){
      setDownloadLoader(true);
    }
    let payloadValue = {
      fromDate: fromDateRef.current.value,
      toDate: todatRef.current.value,
      type: typeRef.current.value,
      fileType: fileType,
      partnerCode: localStorage.getItem("userId") || ""
    //   apCode: code,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getApPayoutList = await axios.post(
        Partner_Payout_Rms.GetMasterAPList_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const response = ApiResDecrypt(getApPayoutList?.data);
    //   const res = response.data.partnerPayoutDetailsList
          const res = response.data

      console.log('res',res);
        if (res) {
        if (typeRef.current.value === "brokerage") {
          if (fileType === "grid") {
            setRmsData(res.partnerPayoutDetailsList);
          } else {
            window.open(res, "_self", "noopener,noreferrer");
            toast.success("Excel download successfully");
          }
          // setApproveOrNot(res.apBrokerage[0].apApproved);
        }
        // else if (typeRef.current.value === "mtf/las") {
        //   setRmsData(res.apMtf);
        // } else if (typeRef.current.value === "amc") {
        //   setRmsData(res.apAmc);
        // } else if (typeRef.current.value === "slab wise") {
        //   setRmsData(res.apSlab);
        // }
      } else {
        setRmsData([]);
        toast.error("Data not exist");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setLoader(false);
      setDownloadLoader(false);
    }
  };


 const getPartnerRawData = async () => {
  setrawDownloadLoader(true);
  try {
    const getList = await axios.get(
      Partner_Payout_Rms.GetPartnerRawData_URL,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
        },
      }
    );
    const res = getList?.data;
    if (res?.status === 0) {
      window.open(res?.data, "_self", "noopener,noreferrer");
      toast.success("Excel download successfully");
    } else {
      toast.error(res?.message);
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.message);
  } finally{
    setrawDownloadLoader(false);
  }
};

  //insert update
  const insertPayoutDetails = async (new_users) => {
    let payloadValue = { payouts: new_users };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getPayoutList = await axios.post(
        Partner_Payout_Rms.InsertPayoutDetails_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      console.log("getPayoutList",getPayoutList)
      const res = ApiResDecrypt(getPayoutList?.data);
      console.log(res, "res999");
      if (res?.status === 0) {
        toast.success(res?.data);
        getApPayoutDetailList("grid", "")
        // resetBtn();
      } else {
        toast.error(res.message);
      }
      // getApPayoutDetailList();
      // document.getElementById("select-all-payout").checked = false;
      // let individualTrue = document.querySelectorAll(".activeData");
      // for (let data of individualTrue) {
      //   data.checked = false;
      // }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setInsertloadBtn(false);
    }
  };
  const approveInsertBtn = () => {
    
    let ApproveState = getFormData.onFormState();
    let new_data = getFormData.onApprove("Approved");
//    debugger
    if (new_data?.length > 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      document
        .querySelector(".payout-brokerage-wrapper")
        .scrollTo({ left: 0, behavior: "smooth" });
      document
        .querySelector(".ap-payout-wrapper .ap_master_table .table tbody")
        .scrollTo({ top: 0, behavior: "smooth" });
      setInsertloadBtn(true);
      insertPayoutDetails(new_data);
    } else {
      toast.error("Choose atleast 1 item to Approve");
    }
  };

  //end insert

  const downloadOnClick = (fileType, codeAp) => {
    
    getApPayoutDetailList(fileType, codeAp);
  };

  const OnChangeDepositToDeductAmt = (e, code, id) => {
    const newState = rmsData.map((obj) => {
      if (obj.apId === id) {
        return { ...obj, depositToDeduct: Number(e.target.value) };
      }
      return obj;
    });
    setRmsData(newState);
  };
  const OnChangeDepositAmt = (e, code, id) => {
    const newState = rmsData.map((obj) => {
      if (obj.apId === id) {
        return { ...obj, depositAmt: Number(e.target.value) };
      }
      return obj;
    });
    setRmsData(newState);
  };

  // Add these handlers
const handleFromDateChange = (e) => {
  fromDateRef.current.value = e.target.value;
  if (e.target.value) setFromDateError(""); // Clear error once a value is selected
};

const handleToDateChange = (e) => {
  todatRef.current.value = e.target.value;
  if (e.target.value) setToDateError(""); // Clear error once a value is selected
};

  return (
    <>
      <Header portal={"RM"} title={"Partner Payout"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="ap-payout-wrapper">
        <div className="card-box">
          <form
            className="row input-field-wrapper"
            onSubmit={(e) => onSubmit(e)}
          >
            <div className="col-md-3 col-sm-6 col-6">
              <div className="form-group">
                <label className="form-label">{Constants.From_Date}</label>
                <input
                  type="date"
                  // placeholder="DD-MM-YYYY"
                  className="datepicker form-control text-uppercase"
                  id="FromDateApPayout"
                  ref={fromDateRef}
                  max={CommonDate.onemonthBelow}
                  onChange={handleFromDateChange}
                />
                    {fromDateError && <div className="to-date-error" style={{ color: "red" }}>{fromDateError}</div>}

                {/* {errorResp && <div className="to-date-error">{errorResp}</div>} */}
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-6">
              <div className="form-group">
                <label className="form-label">{Constants.To_Date}</label>
                <input
                  type="date"
                  ref={todatRef}
                  className="datepicker form-control text-uppercase"
                  max={CommonDate.toDateMax}
                  id="ToDateApPayout"
                  onChange={handleToDateChange}
                />
                    {toDateError && <div className="to-date-error" style={{ color: "red" }}>{toDateError}</div>}
                 {/* {errorResp && <div className="to-date-error">{errorResp}</div>} */}
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-12">
              <div className="form-group disabled-cursor" >
                <label className="form-label">Type:</label>
                <select
                  className="report-custom-select product-select"
                  onChange={handleType}
                  ref={typeRef}
                  disabled
                >
                  {/* <option value="">--Select Type--</option> */}
                  <option
                    value="brokerage"
                    defaultChecked
                    style={{ display: "none" }}
                  >
                    Brokerage
                  </option>
                  {/* <option value="mtf/las">MTF</option>
                  <option value="amc">AMC</option>
                  <option value="slab wise">Slab Wise</option> */}
                </select>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-6">
              <div className="save-reset-btn ">
                <button value="grid" type="submit" className="margin-save-btn">
                  {Constants.Submit}
                </button>
                <button
                  value="grid"
                  type="button"
                  className="margin-reset-btn"
                  onClick={() => resetBtn()}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>

          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : rmsData.length > 0 ? (
              <div>
                {
                  typeRef.current.value === "brokerage" && (
                    <PartnerPayoutBrokerage
                      rmsData={rmsData}
                      OnChangeDepositToDeductAmt={OnChangeDepositToDeductAmt}
                      OnChangeDepositAmt={OnChangeDepositAmt}
                      getFormData={getFormData}
                      downloadOnClick={downloadOnClick}
                      getPartnerRawData={getPartnerRawData}
                      downloadLoader={downloadLoader}
                      rawDownloadLoader={rawDownloadLoader}
                    />
                  )
                  // : typeRef.current.value === "mtf/las" ? (
                  //   <MTFPayout rmsData={rmsData} />
                  // ) : typeRef.current.value === "amc" ? (
                  //   <AMCPayout rmsData={rmsData} />
                  // ) : (
                  //   <SlabWiseApPayout rmsData={rmsData} />
                  // )
                }
                {typeRef.current.value === "brokerage" ? (
                  <div className="wrap-buttons">
                    <div className="approve-reject-btn">
                      <button
                        value="grid"
                        className="approve-btn"
                        onClick={approveInsertBtn}
                      >
                        {insertBtnLoader ? (
                          <div className="download-loader">
                            <RoundLoader h={"10"} />
                          </div>
                        ) : (
                          "Approve"
                        )}
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default PartnerPayout;
